import React, { useRef } from 'react';
import { Pressable } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useThemedHex } from '@/hooks/use-theme-colors';

export interface BrandColorPickerProps {
  /** Cor atual em #RRGGBB. */
  value: string;
  /** Chamado com a cor escolhida (#RRGGBB). */
  onSelect: (hex: string) => void;
}

/**
 * Web: o swatch abre a roda de cores nativa do sistema (input type="color").
 */
export function BrandColorPicker({ value, onSelect }: BrandColorPickerProps) {
  const th = useThemedHex();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const safe = /^#[0-9a-fA-F]{6}$/.test(value) ? value.toLowerCase() : '#fd5001';

  return (
    <Pressable
      onPress={() => inputRef.current?.click()}
      accessibilityRole="button"
      accessibilityLabel="Abrir roda de cores"
      style={{
        width: 36,
        height: 36,
        borderRadius: 18,
        backgroundColor: safe,
        borderWidth: 1,
        borderColor: th('#E5E5E5'),
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Ionicons name="color-palette-outline" size={16} color="#fff" />
      {React.createElement('input', {
        ref: inputRef,
        type: 'color',
        value: safe,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
          onSelect(e.target.value.toUpperCase()),
        style: {
          position: 'absolute',
          width: 1,
          height: 1,
          opacity: 0,
          border: 0,
          padding: 0,
          pointerEvents: 'none',
        },
      })}
    </Pressable>
  );
}
